// extracted by mini-css-extract-plugin
module.exports = {"formButton":"inputButton_formButton__4Wkpr","linkClass":"inputButton_linkClass__3tZ-I","buttonLight":"inputButton_buttonLight__U3ics","btn":"inputButton_btn__KppJ5"};